// extracted by mini-css-extract-plugin
module.exports = {"title":"awards_title__2dWJd","awards":"awards_awards__1crgj","hidden":"awards_hidden__1_F-C","animated":"awards_animated__2URjD"};